export const filters = () => ({
  RegularFilters: [
    {
      label: 'Archived',
      field: 'archived',
      type: 'toggle',
    },
  ],
});
